import React from 'react'
import { AdSlot } from 'wildsky-components'

const AdFooter = () => {
  return <AdSlot type="bottom_rail" tagless lazy={false} />
}

export default AdFooter
